import { useAppDispatch, useAppSelector } from "@/data/hooks";
import { selectExamBacktrackDisabled } from "@/features/assignment";
import { useSheetQuery } from "@/generated/graphql";
import { useAnswerBlocks } from "@/graphql/hooks";
import { selectExamStage } from "@/stores/selectors";

import { goToPage, selectCurrentPage } from "../../answer-slice";
import { AnswerSidebar } from "./answer-sidebar";

interface Props {
  assessmentId: string;
  workId: string;
}

/**
 * Redux connected wrapper for AnswerSidebar.
 */
export function ConnectedAnswerSidebar({ workId }: Props) {
  const currentPage = useAppSelector(selectCurrentPage);
  const dispatch = useAppDispatch();
  const answerBlocks = useAnswerBlocks(workId);
  const examStage = useAppSelector(selectExamStage);
  const examBacktrackDisabled = useAppSelector(selectExamBacktrackDisabled);
  const { data: sheetData } = useSheetQuery({
    variables: { workId },
    notifyOnNetworkStatusChange: true,
  });

  return (
    <AnswerSidebar
      answers={answerBlocks}
      page={currentPage}
      onSelectPage={(page) => dispatch(goToPage(page))}
      locked={examStage !== "open"}
      hasResources={(sheetData?.work.sheet?.resources.length ?? 0) > 0}
      disableBacktrack={examBacktrackDisabled}
    />
  );
}
